<template>
  <div v-if="hasContent" class="pgn-header-card" :class="cardClasses">
    <div class="pgn-header-top">
      <div v-if="players.white" class="pgn-player white">
        <span class="pgn-header-label">Blancas</span>
        <span class="pgn-header-value" :title="players.white">{{ players.white }}</span>
      </div>
      <div v-if="players.result" class="pgn-result">
        {{ players.result }}
      </div>
      <div v-if="players.black" class="pgn-player black">
        <span class="pgn-header-label">Negras</span>
        <span class="pgn-header-value" :title="players.black">{{ players.black }}</span>
      </div>
    </div>
    <div v-if="showMetadata && metadataToDisplay.length" class="pgn-header-grid">
      <div
        v-for="item in metadataToDisplay"
        :key="item.key"
        class="pgn-header-item"
      >
        <span class="pgn-header-label">{{ item.label }}</span>
        <span class="pgn-header-value" :title="item.value">{{ item.value }}</span>
      </div>
    </div>
  </div>
  <p></p>
</template>

<script>
const HEADER_LABELS = {
  Event: 'Evento',
  Site: 'Lugar',
  Date: 'Fecha',
  Round: 'Ronda',
  ECO: 'ECO',
  Opening: 'Apertura'
}

const PRIMARY_HEADER_ORDER = ['Event', 'Site', 'Date', 'Round', 'ECO', 'Opening']
const IGNORED_KEYS = ['White', 'Black', 'Result', 'WhiteElo', 'BlackElo']

function extractHeaders (pgn) {
  if (!pgn || typeof pgn !== 'string') {
    return {}
  }

  const headerRegex = /\[(\w+)\s+"([^"]*)"\]/g
  const headers = {}
  let match = headerRegex.exec(pgn)

  while (match) {
    headers[match[1]] = match[2]
    match = headerRegex.exec(pgn)
  }

  return headers
}

export default {
  name: 'PgnHeaderCard',
  props: {
    pgn: {
      type: String,
      default: ''
    },
    showMetadata: {
      type: Boolean,
      default: true
    },
    limitMetadata: {
      type: Number,
      default: 6
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headers () {
      return extractHeaders(this.pgn)
    },
    players () {
      const white = this.headers.WhiteElo
        ? `${this.headers.White || ''} (${this.headers.WhiteElo})`
        : this.headers.White || ''
      const black = this.headers.BlackElo
        ? `${this.headers.Black || ''} (${this.headers.BlackElo})`
        : this.headers.Black || ''

      return {
        white: white.trim(),
        black: black.trim(),
        result: (this.headers.Result && this.headers.Result !== '*') ? this.headers.Result : ''
      }
    },
    metadataToDisplay () {
      const items = []

      PRIMARY_HEADER_ORDER.forEach((key) => {
        const value = this.headers[key]
        if (value) {
          items.push({
            key,
            label: HEADER_LABELS[key] || key,
            value
          })
        }
      })

      Object.keys(this.headers)
        .filter((key) => !PRIMARY_HEADER_ORDER.includes(key) && !IGNORED_KEYS.includes(key))
        .slice(0, Math.max(0, this.limitMetadata - items.length))
        .forEach((key) => {
          items.push({
            key,
            label: key.replace(/([A-Z])/g, ' $1').trim(),
            value: this.headers[key]
          })
        })

      return items.slice(0, this.limitMetadata)
    },
    hasContent () {
      return Boolean(this.players.white || this.players.black || this.players.result || this.metadataToDisplay.length)
    },
    cardClasses () {
      return {
        'pgn-header-card--compact': this.compact,
        'pgn-header-card--lean': !this.showMetadata
      }
    }
  }
}
</script>

<style scoped>
.pgn-header-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, rgba(96, 125, 139, 0.15), rgba(103, 58, 183, 0.15));
  border: 1px solid rgba(96, 125, 139, 0.4);
  border-radius: 5px;
  padding: 3px 6px;
  box-sizing: border-box;
  color: #263238;
  /* min-height: 150px;
  max-height: 220px;
  overflow: hidden; */
}

.pgn-header-card--compact {
  /* min-height: 120px;
  max-height: 160px; */
  padding: 3px 6px;
}

.pgn-header-card--lean {
  min-height: auto;
  max-height: none;
  padding: 2px 4px;
}

.pgn-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 12px;*/ 
  margin-bottom: 12px;
}

.pgn-player {
  flex: 1 1 40%;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
}

.pgn-player.black {
  text-align: left;
  max-width: 40%;
  /* align-items: flex-end; */
}
.pgn-player.white {
  text-align: left;
  max-width: 40%;
  /* align-items: flex-end; */
}

.pgn-result {
  flex: 0 0 auto;
  background: rgba(103, 58, 183, 0.1);
  border: 1px solid rgba(103, 58, 183, 0.25);
  color: #512da8;
  padding: 1px 2px;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-align: center;
}

.pgn-header-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 4px 8px;
}

.pgn-header-card--lean .pgn-header-top {
  margin-bottom: 6px;
}

.pgn-header-card--lean .pgn-player {
  /* gap: 2px;*/
}

.pgn-header-card--lean .pgn-result {
  padding: 2px 5px;
  font-size: 0.85rem;
}

.pgn-header-item {
  display: flex;
  flex-direction: column;
  /* gap: 4px;*/
  background: rgba(255, 255, 255, 0.6);
  border-radius: 5px;
  padding: 1px 2px;
  min-width: 0;
}

.pgn-header-label {
  font-size: 0.6rem;
  /*font-weight: 600;*/
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(38, 50, 56, 0.7);
}

.pgn-header-value {
  font-size: 0.80rem;
  font-weight: 600;
  color: #263238;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 992px) {
  .pgn-header-card {
    /* min-height: 200px;
    max-height: 240px; */
  }
}

@media (max-width: 600px) {
  .pgn-header-card,
  .pgn-header-card--compact {
    min-height: unset;
    max-height: none;
  }

  .pgn-header-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .pgn-player,
  .pgn-player.black {
    align-items: flex-start;
    text-align: left;
    width: 100%;
  }

  .pgn-result {
    width: 100%;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// PgnHeaderCard.vue?69546664